import React, { useState } from "react";
import {
  Container,
  Header,
  TableContainer,
  TableHeader,
  TableBody,
  Pagination,
} from "./Component/TableComponent/Table";
import { CreatUnit } from "./Component/Utils/Utils";
import BulkExport from "./Component/BulkButton/BulkExport";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { FaPlus } from "react-icons/fa";
import BulkImport from "./Component/BulkButton/BulkImport";
import SuccessModel from "../Popup/SuccessModel";

function CreateUnit() {
  const [showopen, setShowOpen] = useState(false);

  return (
    <div className="mt-10">
      <ReactTooltip
        id="main-tooltip"
        place="top"
        effect="solid"
        className="!text-[14px] !rounded-md !px-2 !py-[2px] !text-white z-20 shadow-md"
      />

      <div className="flex justify-between">
        {/* Left section */}
        <div className="flex w-full justify-start items-center gap-3">
          <p className="text-xl text-gray-500 font-semibold">Create Unit</p>

          <button
            onClick={() => setShowOpen(true)}
            data-tooltip-id="main-tooltip"
            data-tooltip-content="Create"
            className="text-sm shadow-sm font-semibold rounded-md px-6 py-2 flex gap-2 items-center 
            justify-center text-center transition-all bg-red-600 text-white hover:bg-red-700"
          >
            <FaPlus size={18} />
            Create
          </button>

          {/* Modal */}
          <CreateUnitModalPop showopen={showopen} setShowOpen={setShowOpen} />
        </div>

        {/* Right section */}
        <div className="flex w-full gap-2 justify-end">
          <BulkImport content={"Import"} />
          <BulkExport content="Export" />
          <Pagination />
        </div>
      </div>

      {/* Table */}
      <Trending_Table />
    </div>
  );
}

export default CreateUnit;

// Table Section
function Trending_Table() {
  const RowHeader = ["Unit", "Unit Description", "Action"];

  return (
    <Container>
      <Header>
        <TableContainer>
          <TableHeader children={RowHeader} />
          <TableBody rows={CreatUnit} />
        </TableContainer>
      </Header>
    </Container>
  );
}

// Create Modal Component
function CreateUnitModalPop({ showopen, setShowOpen }) {
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleCreateClick = () => {
    setShowSuccessModal(true);
  };

  const handleSuccessClose = () => {
    setShowSuccessModal(false);
    setShowOpen(false);
  };

  if (showSuccessModal) {
    return <SuccessModel onClose={handleSuccessClose} />;
  }

  return (
    <>
      {showopen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-md shadow-lg w-[600px] relative">
            <div className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">Create Units</h2>
                <button
                  onClick={() => setShowOpen(false)}
                  className="text-gray-500 text-xl font-bold"
                >
                  &times;
                </button>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Unit<span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Unit"
                    className="w-full border border-gray-300 rounded-md px-3 py-2 outline-none"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">
                    Unit Description<span className="text-red-500">*</span>
                  </label>
                  <textarea
                    placeholder="Description about unit..."
                    className="w-full border border-gray-300 rounded-md px-3 py-2 h-28 resize-none outline-none"
                  ></textarea>
                </div>

                <div className="text-right">
                  <button
                    onClick={handleCreateClick}
                    className="bg-[#009FE3] text-white px-6 py-2 rounded hover:bg-[#0083be]"
                  >
                    Create
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
